// ===================== 📄 ทำไฟล์ PDF ของใบยืม / ใบเบิก (ส่งต่อให้คนอื่นพิมพ์) — ผู้ใช้ขอ 23/10/2569 =====================
// วาดเอกสารแบบเดียวกับหน้าพิมพ์ (docHtml) แล้ววางลงกระดาษ A4 แผ่นเดียว — ภาษาไทยออกตรงตามหน้าจอ (วาดเป็นภาพ)
// ตัวหนังสือใหญ่ขึ้นจากเดิม (ผู้ใช้แจ้งว่าเล็กไป 23/10/2569): ขยายตัวอักษร + ขอบกระดาษแคบ + ขยายเต็มหน้า (ยาวเกินจะย่อให้พอดี 1 หน้า)
// โหลดตัวทำ PDF เฉพาะตอนใช้ (ไม่ทำให้เว็บช้าลงตอนเปิด)
import { docHtml, printLoan, printIssue } from './printForms';

const LAYOUT_PX = 695;          // ความกว้างที่ใช้จัดหน้า = พื้นที่พิมพ์ A4 ขอบ 1.3 ซม. (184 มม.)
// ตัวหนังสือในไฟล์ PDF (หน้าพิมพ์ปกติ 12.5) · ใบเบิกสั้นกว่า → ตัวใหญ่ + แถวสูงขึ้นให้เต็มหน้า · ใบยืม (มีใบส่งคืนครึ่งล่าง) เต็มหน้าที่ 15
const SIZE = { ISSUE: { font: 16, row: 34 }, LOAN: { font: 15, row: 24 } };
const MARGIN_MM = 13, TOP_MM = 20, PAGE_W = 210, PAGE_H = 297;   // ขอบ 1.3 ซม. ทุกด้าน (ผู้ใช้ขอ 23/10/2569 — เครื่องพิมพ์ตัดขอบ)

export async function docPdf(kind, doc, opt) {
  const c = docHtml(kind, doc, opt), { font: FONT_PX, row: ROW_PX } = SIZE[kind] || SIZE.LOAN;
  const html = c.html.replace(/<script>[\s\S]*?<\/script>/g, '')
    .replace('</head>', `<style>html,body{background:#fff}body{width:${LAYOUT_PX}px;margin:0;padding:0;box-sizing:border-box;font-size:${FONT_PX}px}
      .rt{font-size:${FONT_PX + 1}px}.sg>div,.sys,.note2{font-size:${FONT_PX - 1}px}table.it th,table.it td{height:${ROW_PX}px}</style></head>`);
  const [{ default: html2canvas }, { jsPDF }] = await Promise.all([import('html2canvas'), import('jspdf')]);
  const frame = document.createElement('iframe');
  frame.setAttribute('aria-hidden', 'true');
  Object.assign(frame.style, { position: 'fixed', left: '-10000px', top: '0', width: `${LAYOUT_PX}px`, height: '1200px', border: '0' });
  document.body.appendChild(frame);
  try {
    const d = frame.contentDocument;
    d.open(); d.write(html); d.close();
    // รอรูปโลโก้ + ฟอนต์ให้พร้อมก่อนวาด
    await Promise.all([...d.images].map((im) => (im.complete ? null : new Promise((r) => { im.onload = r; im.onerror = r; }))));
    if (d.fonts && d.fonts.ready) await d.fonts.ready;
    const canvas = await html2canvas(d.body, { scale: 2.5, backgroundColor: '#ffffff', useCORS: true, windowWidth: LAYOUT_PX, logging: false });
    const pdf = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait', compress: true });
    // เต็มความกว้างหน้า · ถ้ายาวเกิน 1 หน้า ย่อให้พอดีความสูง (เอกสารต้องอยู่แผ่นเดียวเหมือนแบบฟอร์มจริง)
    // ขอบบน 2 ซม. (เครื่องพิมพ์บางเครื่องตัดหัว QR · ผู้ใช้แจ้ง 28/10/2569)
    const maxW = PAGE_W - MARGIN_MM * 2, maxH = PAGE_H - TOP_MM - MARGIN_MM;
    let w = maxW, h = (canvas.height * w) / canvas.width;
    if (h > maxH) { h = maxH; w = (canvas.width * h) / canvas.height; }
    pdf.addImage(canvas.toDataURL('image/jpeg', 0.92), 'JPEG', (PAGE_W - w) / 2, TOP_MM, w, h);
    return new File([pdf.output('blob')], `${doc.doc_no}.pdf`, { type: 'application/pdf' });
  } finally { frame.remove(); }
}

// ทดสอบในเครื่องเท่านั้น (localhost) — เรียกจากหน้าเว็บได้โดยไม่ต้องเข้าระบบ
if (typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) { window.__hxDocPdf = docPdf; window.__hxPrint = { printLoan, printIssue }; }
